import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PlatformClient } from '../httpClients/PlatformClient/PlatformClient';
import { QUERY_KEYS } from '../queries/consts';
import { MUTATION_KEYS } from './consts';

export const useDisconnectGitProviderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.DISCONNECT_GIT_PROVIDER],
    mutationFn: PlatformClient.disconnectGitProvider,
    onSuccess: (data) => {
      queryClient.setQueriesData({ queryKey: [QUERY_KEYS.USER] }, data);
    },
  });
};
